import styled from 'styled-components';

export const Container = styled.div`
  .page-head {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;

    h4 {
      margin: 0;
      font-weight: 700;
      color: ${(props) => props.theme.$gray900};
    }

    .ia-pill {
      display: inline-flex;
      align-items: center;
      gap: 4px;
      padding: 3px 10px;
      border-radius: 999px;
      font-size: 0.72rem;
      font-weight: 700;
      letter-spacing: 0.04em;
      color: #fff;
      background: linear-gradient(90deg, #007bff, #009f79);

      i {
        font-size: 13px;
      }
    }
  }

  .head-actions {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    margin-top: 8px;
  }

  .page-sub {
    margin: 4px 0 0;
    font-size: 0.92rem;
    color: ${(props) => props.theme.$gray600};
  }

  .trust-chips {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    margin-top: 12px;

    .chip {
      display: inline-flex;
      align-items: center;
      gap: 5px;
      padding: 4px 12px;
      border-radius: 999px;
      border: 1px solid ${(props) => props.theme.$gray300};
      background: #fff;
      font-size: 0.78rem;
      color: ${(props) => props.theme.$gray700};

      i {
        font-size: 14px;
        color: ${(props) => props.theme.$primary_green};
      }
    }
  }

  .search-card {
    margin-top: 16px;
    position: relative;
    background: #fff;
    border: 1px solid ${(props) => props.theme.$gray300};
    border-radius: 10px;
    box-shadow: 0 2px 12px rgba(33, 53, 74, 0.06);

    /* Fio de gradiente no topo: assinatura visual dos recursos com IA.
       Pseudo-elemento (e não border-image) para preservar o border-radius
       e não clipar o menu do select de abrangência. */
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 3px;
      border-radius: 10px 10px 0 0;
      background: linear-gradient(90deg, #007bff, #009f79);
    }
  }

  .search-row {
    display: flex;
    gap: 10px;
    padding: 18px 18px 0;

    .search-input-wrap {
      position: relative;
      flex: 1;
      min-width: 0;

      > i {
        position: absolute;
        left: 12px;
        top: 50%;
        transform: translateY(-50%);
        color: ${(props) => props.theme.$gray500};
        font-size: 20px;
        pointer-events: none;
      }

      input.form-control {
        height: 48px;
        padding-left: 42px;
        padding-right: 36px;
        font-size: 0.98rem;

        &:focus {
          border-color: ${(props) => props.theme.$primary_green};
          box-shadow: 0 0 0 0.2rem rgba(0, 159, 121, 0.15);
        }
      }

      .clear-btn {
        position: absolute;
        right: 8px;
        top: 50%;
        transform: translateY(-50%);
        border: 0;
        background: transparent;
        color: ${(props) => props.theme.$gray500};
        display: flex;
        align-items: center;
        padding: 4px;

        &:hover {
          color: ${(props) => props.theme.$gray700};
        }

        i {
          font-size: 18px;
        }
      }
    }

    .btn-ia {
      height: 48px;
      min-width: 140px;
      color: #fff;
      font-weight: 500;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 6px;

      &:disabled {
        opacity: 0.65;
      }

      i {
        font-size: 19px;
      }
    }

    @media only screen and (max-width: 576px) {
      flex-direction: column;

      .btn-ia {
        width: 100%;
      }
    }
  }

  .filters-row {
    display: flex;
    align-items: center;
    gap: 8px 18px;
    flex-wrap: wrap;
    padding: 14px 18px;
    margin-top: 14px;
    border-top: 1px solid ${(props) => props.theme.$gray200};

    .filter-label {
      display: inline-flex;
      align-items: center;
      gap: 4px;
      font-size: 0.82rem;
      color: ${(props) => props.theme.$gray600};

      i {
        font-size: 16px;
      }
    }

    .period-group {
      display: inline-flex;
      border: 1px solid ${(props) => props.theme.$gray300};
      border-radius: 8px;
      overflow: hidden;

      button {
        border: 0;
        background: #fff;
        padding: 6px 14px;
        font-size: 0.82rem;
        color: ${(props) => props.theme.$gray700};

        & + button {
          border-left: 1px solid ${(props) => props.theme.$gray300};
        }

        &.active {
          background: ${(props) => props.theme.$primary_green};
          color: #fff;
          font-weight: 500;
        }
      }
    }

    .custom-dates {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      font-size: 0.82rem;
      color: ${(props) => props.theme.$gray600};

      input {
        width: 150px;
      }
    }

    .uf-select {
      min-width: 240px;
      flex: 1;
      max-width: 420px;

      .pi-select__control {
        border-color: ${(props) => props.theme.$gray300};
        min-height: 34px;
        font-size: 0.85rem;

        &--is-focused {
          border-color: ${(props) => props.theme.$primary_green};
          box-shadow: 0 0 0 0.2rem rgba(0, 159, 121, 0.15);
        }
      }

      .pi-select__multi-value {
        background: ${(props) => props.theme.$bg_green};

        .pi-select__multi-value__label {
          color: ${(props) => props.theme.$dark_green};
          font-weight: 500;
        }
      }

      .pi-select__menu {
        z-index: 50;
      }
    }

    .clear-filters {
      border: 0;
      background: transparent;
      display: inline-flex;
      align-items: center;
      gap: 4px;
      font-size: 0.82rem;
      color: ${(props) => props.theme.$gray600};

      &:hover {
        color: ${(props) => props.theme.$danger};
      }

      i {
        font-size: 15px;
      }
    }
  }

  .suggestions {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    margin-top: 14px;

    .suggestions-label {
      font-size: 0.8rem;
      color: ${(props) => props.theme.$gray500};
    }

    button {
      border: 1px solid ${(props) => props.theme.$gray300};
      background: #fff;
      border-radius: 999px;
      padding: 5px 14px;
      font-size: 0.82rem;
      color: ${(props) => props.theme.$gray700};
      transition: border-color 0.15s, color 0.15s, background 0.15s;

      &:hover {
        border-color: ${(props) => props.theme.$primary_green};
        color: ${(props) => props.theme.$dark_green};
        background: ${(props) => props.theme.$bg_green};
      }
    }
  }
`;
